import loadable from '@loadable/component';

export const OrgDashboardRepostVolopPageContainerLoadable = loadable(
  () => import('./OrgDashboardRepostVolopPageContainer'),
  {
    resolveComponent: (module) => module.OrgDashboardRepostVolopPageContainer,
    ssr: false,
  },
);
